// src/config/firebase.js
import { initializeApp } from 'firebase/app'
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, updateProfile, updatePassword } from 'firebase/auth'
import { getFirestore, collection, addDoc, getDocs, query, where } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = { 
  apiKey: "AIzaSyAgCjjiF6jhtH936dF3FMS27OWk6fx3HI8", 
  authDomain: "media-app-e7080.firebaseapp.com", 
  projectId: "media-app-e7080", 
  storageBucket: "media-app-e7080.firebasestorage.app", 
  messagingSenderId: "329972459587", 
  appId: "1:329972459587:web:b3fd17df49df2df98b4cf6", 
  measurementId: "G-QWVPKRT8E6" 
}; 

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app);

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

console.log('🔥 Firebase initialized successfully!')

// Auth helpers
export const authService = {
  signIn: async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password)
  },
  
  signUp: async (email, password) => {
    return await createUserWithEmailAndPassword(auth, email, password)
  },
  
  signOut: async () => {
    return await signOut(auth)
  },

  updateProfile: async (user, data) => {
    return await updateProfile(user, data)
  },

  updatePassword: async (user, newPassword) => {
    return await updatePassword(user, newPassword)
  }
}

// Database helpers
export const dbService = {
  // Add document to collection
  add: async (collectionName, data) => {
    return await addDoc(collection(db, collectionName), data)
  },
  
  // Get all documents from collection
  getAll: async (collectionName) => {
    const querySnapshot = await getDocs(collection(db, collectionName))
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
  },
  
  // Get documents with query
  getWhere: async (collectionName, field, operator, value) => {
    const q = query(collection(db, collectionName), where(field, operator, value))
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
  }
}

export default app
